import React from 'react';
import { AlertCircle, Check, Clock } from 'lucide-react';

export const ChatDeliveryStatus = ({ meta }) => {
  if (!meta?.outbound_attempt_id || !meta.delivery_status) return null;
  const status = meta.delivery_status;
  const error = status === 'failed' || status === 'unknown';
  const label = { sending: 'Submitting to GHL', accepted: 'Accepted by GHL', sent: 'Sent by GHL',
    delivered: 'Delivered', read: 'Read', failed: 'Delivery failed', unknown: 'Delivery unconfirmed' }[status] || 'Delivery unconfirmed';
  const Icon = error ? AlertCircle : ['delivered', 'read'].includes(status) ? Check : Clock;
  const id = `chat-delivery-${meta.outbound_attempt_id}`;
  return <div data-testid={id} className={`mt-1.5 text-[10px] leading-relaxed [overflow-wrap:anywhere] ${error ? 'text-rose-400' : 'text-cyan-500'}`} role={error ? 'status' : undefined}>
    <span className="inline-flex items-center gap-1" data-testid={`${id}-label`}><Icon size={11} className="shrink-0" />{label}</span>
    {error && meta.delivery_reason && <p data-testid={`${id}-reason`}>{meta.delivery_reason}</p>}
  </div>;
};